import {
  DEVELOPER_CREATE_REQUEST,
  DEVELOPER_CREATE_SUCCESS,
  DEVELOPER_CREATE_FAIL,
  DEVELOPER_CREATE_RESET,
  DEVELOPER_UPDATE_REQUEST,
  DEVELOPER_UPDATE_SUCCESS,
  DEVELOPER_UPDATE_FAIL,
  DEVELOPER_UPDATE_RESET,
  DEVELOPER_DELETE_REQUEST,
  DEVELOPER_DELETE_SUCCESS,
  DEVELOPER_DELETE_FAIL,
  DEVELOPER_DELETE_RESET,
  DEVELOPER_DETAILS_REQUEST,
  DEVELOPER_DETAILS_SUCCESS,
  DEVELOPER_DETAILS_FAIL,
  DEVELOPER_DETAILS_RESET,
} from "../constants/developerConstants";

// For create
// 1) CREATE
export const developerCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case DEVELOPER_CREATE_REQUEST:
      return { loading: true };
    case DEVELOPER_CREATE_SUCCESS:
      return {
        loading: false,
        developerCreateSuccess: true,
        developer: action.payload,
      };
    case DEVELOPER_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case DEVELOPER_CREATE_RESET:
      return {}; // clears out the slice to an empty object
    default:
      return state;
  }
};

// 2) UPDATE
export const developerUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case DEVELOPER_UPDATE_REQUEST:
      return { loading: true };
    case DEVELOPER_UPDATE_SUCCESS:
      return {
        loading: false,
        developerUpdateSuccess: true,
        message: action.payload,
      };
    case DEVELOPER_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case DEVELOPER_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// 3) DELETE
export const developerDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case DEVELOPER_DELETE_REQUEST:
      return { loading: true };
    case DEVELOPER_DELETE_SUCCESS:
      return {
        loading: false,
        developerDeleteSuccess: true,
        message: action.payload,
      };
    case DEVELOPER_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case DEVELOPER_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// 4) GET SINGLE DEVELOPER
export const developerDetailsReducer = (
  state = { developer: null },
  action
) => {
  switch (action.type) {
    case DEVELOPER_DETAILS_REQUEST:
      return { loading: true, developer: null };
    case DEVELOPER_DETAILS_SUCCESS:
      return { loading: false, developer: action.payload };
    case DEVELOPER_DETAILS_FAIL:
      return { loading: false, error: action.payload, developer: null };
    case DEVELOPER_DETAILS_RESET:
      return { developer: null };
    default:
      return state;
  }
};
